import Axios from "axios";
import {
  SET_LC_PAYMENT_TERM_LIST,
  UNSET_LC_PAYMENT_TERM_LIST,
} from "@/store/mutation-types";
import { saveUpdateLcPaymentTerm, getLcPaymentTermList } from "@/store/api";

const state = {
  lcPaymentTermList: [],
};

const getters = {
  getLcPaymentTermList(state) {
    return state.lcPaymentTermList;
  },
};

const mutations = {
  [SET_LC_PAYMENT_TERM_LIST](state, data) {
    state.lcPaymentTermList = data;
  },
  [UNSET_LC_PAYMENT_TERM_LIST](state) {
    state.lcPaymentTermList = [];
  },
};

const actions = {
  saveUpdateLcPaymentTerm({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateLcPaymentTerm, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  },

  getLcPaymentTermList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getLcPaymentTermList, data)
        .then(function (response) {
          commit("SET_LC_PAYMENT_TERM_LIST", response.data.data);
          resolve(response);
        })
        .catch(function (error) {
          commit("UNSET_LC_PAYMENT_TERM_LIST");
          reject(error);
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

